import * as React from 'react';
import styled, { css } from 'styled-components';
import { mediaMaxWidth } from '../../../../utils';
const StyledImageSmall = styled.img`
  display: none;
  ${mediaMaxWidth({
  md: css`
      display: block;
      margin: 0 auto;
      max-width: 100%;
    `
})}
`;
const StyledImageMedium = styled.img`
  display: block;
  margin: 0 auto;
  max-width: 100%;

  ${mediaMaxWidth({
  md: css`
      display: none;
    `
})}
`;
export const ImageFeature = ({
  className,
  mobileImage,
  image
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, image && /*#__PURE__*/React.createElement(StyledImageMedium, {
    className: className,
    alt: image.title || 'Unnamed Image',
    src: `${image.url}`
  }), mobileImage && /*#__PURE__*/React.createElement(StyledImageSmall, {
    className: className,
    alt: mobileImage.title || 'Unnamed Image',
    src: `${mobileImage.url}`
  }));
};